import React from 'react'
import {translateProductState} from 'lib/strings'
import './index.scss'

const ProductState = ({product}) => {
  const classNames = ['product-state', product.state]
  if (product.canProvideUserInput) {
    classNames.push('provide-input')
  }

  return (
    <span className={classNames.join(' ').trim()}>
      {translateProductState(product)}
    </span>
  )
}

export default ProductState
